import axios from 'axios';

export const reportService = {
  getARAging: async (params = {}) => {
    const response = await axios.get('/api/reports/ar-aging', { params });
    return response.data;
  },
  getSalesSummary: async (params = {}) => {
    const response = await axios.get('/api/reports/sales-summary', { params });
    return response.data;
  },
  getLaborByOrder: async (params = {}) => {
    const response = await axios.get('/api/reports/labor-by-order', { params });
    return response.data;
  },
  getLaborOrderDetail: async (workOrderId, params = {}) => {
    const response = await axios.get(`/api/reports/labor-by-order/${workOrderId}`, { params });
    return response.data;
  },
  getTaskAdoption: async (params = {}) => {
    const response = await axios.get('/api/reports/task-adoption', { params });
    return response.data;
  }
};
